var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1422 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1443 15c11.6 0 21 9.402 21 21s-9.4 21-21 21-21-9.402-21-21 9.4-21 21-21Z",
    style: {
      fill: "rgb(45, 169, 226)"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1443 15c11.6 0 21 9.402 21 21s-9.4 21-21 21-21-9.402-21-21 9.4-21 21-21Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1464 61h-42c.21-2.922 2.31-8.029 4.56-8.948l2.41-.711c2.06-1.242 4.11-2.485 6.17-3.728-.02-.512.03-.864.18-1.154l3.03-.977-.18-.799c-.5-1.124-1.01-2.249-1.52-3.373-.23-.918-.47-1.835-.71-2.753v-.177c-.21-.059-.42-.119-.62-.178-.45-.61-1.16-2.64-.81-3.551l.54-.444c.14-.331-.44-2.78-.27-3.728.48-2.731 1.74-4.831 3.75-6.037 4.59-2.747 11.36-.174 12.42 4.084.43 1.696.18 3.537.09 5.149-.03.541.4.619.54.976.58 1.557-.43 3.048-1.43 3.462-.07 3.093-1.84 4.395-1.88 7.369h.18c.89.355 1.79.71 2.68 1.065l.45 1.155 3.3 2.219c3.53 2.097 8.89 5.757 9.12 11.079Z",
    style: {
      fill: "#f5f5f5",
      fillOpacity: 0.9
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.3f22d11cd114b2adbc40ffaa64793965.svg";
export { ForwardRef as ReactComponent };